 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		3: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"0dc4f6a8cc697b8b06b49224452a55371395cee6","1":"styles","2":"fdcd20e7f2c851b66d2e4ef7399af76c2f701e99","6":"component---cache-caches-gatsby-plugin-offline-app-shell-js","7":"component---src-pages-404-tsx","8":"component---src-pages-contact-us-contact-information-office-map-tsx","9":"component---src-pages-disclaimer-tsx","10":"component---src-pages-index-tsx","11":"component---src-pages-instructions-after-treatment-tsx","12":"component---src-pages-instructions-before-endodontic-treatment-tsx","13":"component---src-pages-instructions-general-instructions-tsx","14":"component---src-pages-meet-us-meet-the-doctor-tsx","15":"component---src-pages-patient-information-endodontic-faq-tsx","16":"component---src-pages-patient-information-financial-policy-tsx","17":"component---src-pages-patient-information-first-visit-tsx","18":"component---src-pages-patient-information-insurance-tsx","19":"component---src-pages-patient-information-introduction-tsx","20":"component---src-pages-patient-information-patient-registration-tsx","21":"component---src-pages-patient-information-scheduling-tsx","22":"component---src-pages-privacy-policy-tsx","23":"component---src-pages-procedures-apicoectomy-tsx","24":"component---src-pages-procedures-cracked-teeth-tsx","25":"component---src-pages-procedures-endodontic-retreatment-tsx","26":"component---src-pages-procedures-root-canal-therapy-tsx","27":"component---src-pages-procedures-traumatic-injuries-tsx","28":"component---src-pages-referring-doctors-referral-form-tsx","29":"component---src-pages-thank-you-for-contacting-us-tsx","30":"component---src-pages-thank-you-tsx","31":"component---src-templates-template-tsx"}[chunkId]||chunkId) + "-" + {"0":"3aab6ad94da86fa54114","1":"e9d24b1846c7d6eb9685","2":"bbc8c038fb55d9a05c99","6":"6c2775b0c56043fb4c73","7":"cdb78472738b494b9bfb","8":"6c7bc37950d6d51fb336","9":"fa334b38369a91e83dc6","10":"92edb825ae61d761dd5b","11":"af133a203900b2a8bafd","12":"a52ba7301213a43b1bf4","13":"0856afdbabe5533cb438","14":"4309d64859b46478d9ec","15":"57c65a4225dd7b6d0c6e","16":"8c0a425ae586f2811084","17":"1493539c2d76aa9910de","18":"b98536ff7e75904b77a3","19":"82183b6c13dd2d0738be","20":"5d51c1425bcb21c9b69f","21":"b58c955cf9ef2fb629d5","22":"ce91abbc382af9824c50","23":"722eb4203baf571c0fb0","24":"3c7e8fcf1c56f5da3754","25":"2c38e6da1f85ae0150ba","26":"dbe30cc6137cbe3db64c","27":"be4775ed593d66ef8781","28":"9e3416b36417a9e64cbb","29":"fcd8016f1f05370b7b45","30":"3313acb8ab8adadce646","31":"a34faace41dab74f29d4","34":"78101ec712987547bfad"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"0dc4f6a8cc697b8b06b49224452a55371395cee6","1":"styles","2":"fdcd20e7f2c851b66d2e4ef7399af76c2f701e99","6":"component---cache-caches-gatsby-plugin-offline-app-shell-js","7":"component---src-pages-404-tsx","8":"component---src-pages-contact-us-contact-information-office-map-tsx","9":"component---src-pages-disclaimer-tsx","10":"component---src-pages-index-tsx","11":"component---src-pages-instructions-after-treatment-tsx","12":"component---src-pages-instructions-before-endodontic-treatment-tsx","13":"component---src-pages-instructions-general-instructions-tsx","14":"component---src-pages-meet-us-meet-the-doctor-tsx","15":"component---src-pages-patient-information-endodontic-faq-tsx","16":"component---src-pages-patient-information-financial-policy-tsx","17":"component---src-pages-patient-information-first-visit-tsx","18":"component---src-pages-patient-information-insurance-tsx","19":"component---src-pages-patient-information-introduction-tsx","20":"component---src-pages-patient-information-patient-registration-tsx","21":"component---src-pages-patient-information-scheduling-tsx","22":"component---src-pages-privacy-policy-tsx","23":"component---src-pages-procedures-apicoectomy-tsx","24":"component---src-pages-procedures-cracked-teeth-tsx","25":"component---src-pages-procedures-endodontic-retreatment-tsx","26":"component---src-pages-procedures-root-canal-therapy-tsx","27":"component---src-pages-procedures-traumatic-injuries-tsx","28":"component---src-pages-referring-doctors-referral-form-tsx","29":"component---src-pages-thank-you-for-contacting-us-tsx","30":"component---src-pages-thank-you-tsx","31":"component---src-templates-template-tsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"c95739b95be3c9c1272a","2":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
